import React from 'react';
import { CartItem } from 'src/models/cart/_types';

import { ItemSettings } from './ItemSettings';
import { PaymentStep, usePaymentDialogContext } from './PaymentDialogContext';

interface PaymentDialogItemSettingsProps {
  item: CartItem;
  onSave: (updatedItem: CartItem) => void;
  editing?: boolean;
}

/**
 * Wrapper for ItemSettings that provides PaymentDialog-specific submit behavior
 */
export const PaymentDialogItemSettings: React.FC<
  PaymentDialogItemSettingsProps
> = ({ item, onSave, editing = false }) => {
  const { cart, setCart, setCurrentStep, user } = usePaymentDialogContext();

  const handleSubmit = (updatedItem: CartItem) => {
    // Update cart with the new item
    const cartItem = cart.cartItems.find(
      (cartItem) => cartItem.item == item.item
    );

    setCart({
      ...cart,
      cartItems: [
        ...cart.cartItems.filter((item) => item != cartItem),
        updatedItem,
      ],
    });

    // Call the original onSave callback
    onSave(updatedItem);

    // Navigate back to Bag step
    setCurrentStep(PaymentStep.Bag);
  };

  return (
    <ItemSettings
      item={item}
      onSubmit={handleSubmit}
      editing={editing}
      user={user}
    />
  );
};
